"use client"

import Script from "next/script"

/**
 * TrustDecision Web&H5 SDK 注入组件（最少配置）
 * 仅依赖以下必需环境变量：
 * - NEXT_PUBLIC_TD_BASE_URL: SDK Base URL（必填，指纹与 BotD 共用）
 * - NEXT_PUBLIC_TD_PARTNER: 合作方名称（必填）
 */
export function TdTrustDecision() {
	const baseUrl = process.env.NEXT_PUBLIC_TD_BASE_URL
	const partner = process.env.NEXT_PUBLIC_TD_PARTNER
	const botdUrl = process.env.NEXT_PUBLIC_TD_BOTD_URL

	if (!baseUrl || !partner) {
		return null
	}

	const initCode = `
    (function(){
      try {
        // 初始化 TrustDevice 指纹采集
        window._fmOpt = {
          partner: ${JSON.stringify(partner)},
          success: function(data){
            try {
              window.__td_blackbox = data;
              try { localStorage.setItem('td_blackbox', data); } catch(e){}
            } catch(e){}
          }
        };
        var fm = document.createElement('script');
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = ${JSON.stringify(baseUrl)} + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(fm, s);

        // 初始化 BotD（接口签名）
        window._TDBotD = window._TDBotD || {};
        var botd = document.createElement('script');
        botd.type = 'text/javascript'; botd.async = true;
        botd.src = ${JSON.stringify(botdUrl)} + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        s.parentNode.insertBefore(botd, s);

        // 便捷方法：获取签名（失败返回空串）
        window.__td_getSign = function(path){
          try {
            if(window._TDBotD && typeof window._TDBotD.sign === 'function'){
              var r = window._TDBotD.sign({ path: String(path || '') });
              return (r && r.code === 0 && r.sign) ? r.sign : '';
            }
          } catch(e) {}
          return '';
        };
      } catch (e) {
        console.error('TrustDecision init error', e);
      }
    })();
  `

	return (
		<Script
			id="td-trustdecision-init"
			strategy="afterInteractive"
			dangerouslySetInnerHTML={{ __html: initCode }}
		/>
	)
}

declare global {
	interface Window {
		_fmOpt?: any
		_TDBotD?: any
		__td_blackbox?: string
		__td_getSign?: (path: string) => string
	}
}

export default TdTrustDecision
